<select [(ngModel)]="value" class="form-control" (blur)="onBlur()" (ngModelChange)="modelChange($event)" [disabled]="disabled">
  <option *ngFor="let profile of profiles" [value]="profile.ProfileId">
    <span *ngIf="profile.ProfileId == 0 && includeSelectValue == true">{{ profile.ReportName }}&nbsp;...</span>
    <span *ngIf="profile.ProfileId > 0 || includeSelectValue == false">{{ profile.ReportName }}&nbsp;&nbsp;({{ profile.ProfileId }})</span>
  </option>
</select>
